import { memo } from 'react';
import { SVGType } from '../types';

export const ApplyMoreFiltersIcon = memo(({ stroke, size = 18, ...rest }: SVGType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 20 18">
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6.121 1.879A3 3 0 111.88 6.12 3 3 0 016.12 1.88zM18 4H7M18.121 11.879a3 3 0 11-4.242 4.242 3 3 0 014.242-4.242zM2 14h11"
    ></path>
  </svg>
));
